module.exports = __webpack_public_path__ + "img/TurningStool1.70a9ef3c.svg";